import { render, staticRenderFns } from "./ViewOrg.vue?vue&type=template&id=00117631&scoped=true&lang=pug&"
import script from "./ViewOrg.vue?vue&type=script&lang=js&"
export * from "./ViewOrg.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrg.vue?vue&type=style&index=0&id=00117631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00117631",
  null
  
)

export default component.exports